<template>
  <section class="intro">
    <IntroPackage
      v-if="showPackage"
      @remove="showPackage = false"
    />
    <div class="container">
      <header class="header">
        <svg :class="busClasses" width="59" height="32.23" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59 32.23"><path d="M8.73 13.54H1.08a1.08 1.08 0 1 1 0-2.15h7.65a1.08 1.08 0 1 1 0 2.15zm2.15-4.78H6.1a1.08 1.08 0 0 1 0-2.15h4.78a1.08 1.08 0 0 1 0 2.15zm0 9.81H6.1a1.08 1.08 0 0 1 0-2.15h4.78a1.08 1.08 0 0 1 0 2.15zm47.73.3l-2.74-3.29a2.55 2.55 0 0 1-.15-.58L53.59 2.18A2.55 2.55 0 0 0 51.07 0H14.7v27a2.23 2.23 0 0 0 2.23 2.23h1.54a4.66 4.66 0 0 1 9.33 0h18.12a4.66 4.66 0 0 1 9.33 0H56a3 3 0 0 0 3-3v-6.09a2.42 2.42 0 0 0-.39-1.27z"/><circle cx="23.14" cy="29.27" r="2.96"/><circle cx="50.59" cy="29.27" r="2.96"/></svg>
        <h1 class="title">
          Retour Rumoer
        </h1>
        <p class="subtitle">De groeipijn van onze bezorgingsstaat</p>
      </header>
      <Content large>
        <p>Vier paar schoenen, drie maten van die leuke broek, en nog twee shirts erbij. Online shoppen was nog nooit zo makkelijk, want hé: als het niet past, dan stuur je het toch gewoon weer terug?</p>
      </Content>
      <Content>
        <p>Nederlanders zijn Europees kampioen <i>retourzenden</i>. Maar wat gebeurt er eigenlijk met al die pakjes die jij weer de deur uit doet? En wat zijn de gevolgen van die enorme terugstuurfetisj?</p>
      </Content>
    </div>
  </section>
</template>

<script>
import IntroPackage from '@/components/intro-package'
import { Content } from '@/components/chapter'
import { chapterMixin } from '@/mixins'

export default {
  name: 'Intro',
  data () {
    return {
      showPackage: true
    }
  },
  mixins: [chapterMixin],
  components: {
    Content,
    IntroPackage
  },
  computed: {
    busClasses () {
      return {
        'bus': true,
        'drive': !this.showPackage
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.intro {
  padding-bottom: 7em;

  @media (max-width: 767px) {
    padding-bottom: 5em;
  }
}

.header {
  text-transform: uppercase;
  line-height: $lh-heading;
  text-align: center;
  margin-bottom: 2em;
}

.bus {
  margin-bottom: 1em;
  position: relative;
  left: -5px;
  fill: white;
}

@keyframes drive {
  0%,
  100% {
    transform: translateX(0px);
    opacity: 1;
  }
  100% {
    fill: $c-pink;
  }
  45% {
    opacity: 0;
    transform: translateX(20px);
  }
  55% {
    opacity: 0;
    fill: $c-pink;
    transform: translateX(-20px);
  }
}

.drive {
  animation: drive 1700ms forwards 1;
}

.title,
.subtitle {
  margin: 0;
}

.title {
  color: $c-pink;
  font-size: $fs-h1;
}

.subtitle {
  font-size: $fs-h3;
}
</style>
